
import apiConfig from "../../config/apiConfig";
import { URL } from "../../routers/constants";
import { objToQueryString, randomCampaignName, showSuccessToasts } from "../../services/helpers/Helper";
import { END_POINT, LIVE_CAMPAIGN_TYPE } from "../constants";
import { detailCampaign } from "./campaignsAction";
import { setError } from "./errorAction";
import { hideLoading, showLoading } from "./loadingAction";

export const getListLiveCampaign = (currentPage = 1, page_size = 10) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         clientType: '',
         revision: '',
         languageCode: '',
         countryCode: '',
         timestamp: new Date().getTime(),
         page: currentPage,
         page_size,
         campaign_cate: 0
      };
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.LIST_CAMPAIGNS}?${qs}`;
      dispatch(showLoading());
      apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: LIVE_CAMPAIGN_TYPE.FETCHS,
            payload: response.data
         })
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   };

export const createLiveCampaign = (navigate) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         clientType: '',
         revision: '',
         languageCode: '',
         countryCode: '',
         timestamp: new Date().getTime(),
         campaign_name: randomCampaignName(),
         campaign_cate: 0
      };
      dispatch(showLoading());
      apiConfig.post(END_POINT.PAGE_CAMPAIGNS, params).then((response) => {
         const { data: id } = response;
         const url = URL.LIVESTREAM_LIVE_CAMPAIGN_LIST_EDIT.replace(':id', id);
         navigate(url);
         dispatch(getListLiveCampaign());
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }



export const deleteLiveCampaign = (campaign) =>
   async (dispatch) => {
      campaign = {
         ...campaign,
         is_active: -1,
         campaign_cate: 0
      };
      dispatch(showLoading());
      apiConfig.post(END_POINT.PAGE_CAMPAIGNS, campaign).then((response) => {
         dispatch({
            type: LIVE_CAMPAIGN_TYPE.DELETE,
            payload: campaign.id
         });
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }


export const completeLive = (campaign_id, has_stop_close_sales, has_stop_submit_order) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         has_stop_close_sales,
         has_stop_submit_order
      };
      const qs = objToQueryString({
         fb_page_id: page.social_id,
         campaign_id
      });
      dispatch(showLoading());
      const endPoint = `${END_POINT.LIVE_COMPLETE}?${qs}`;
      apiConfig.post(endPoint, params).then(() => {
         showSuccessToasts('Kết thúc chiến dịch thành công');
         dispatch(detailCampaign(campaign_id));
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }


export const afterLiveComplete = (campaign_id, has_stop_close_sales, has_stop_submit_order) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         has_stop_close_sales,
         has_stop_submit_order
      };
      const qs = objToQueryString({
         fb_page_id: page.social_id,
         campaign_id
      });
      dispatch(showLoading());
      const endPoint = `${END_POINT.LIVE_COMPLETE}?${qs}`;
      apiConfig.post(endPoint, params).then(() => {
         dispatch(detailCampaign(campaign_id));
      }).catch((error) => {
         dispatch(setError(error.message))
      }).finally(() => {
         dispatch(hideLoading());
      })
   }